export default {
  title: 'Desempenho semanal',
  messages_sent: 'Mensagens enviadas',
  messages_delivered: 'Mensagens entregues',
  click_rate: 'Taxa média de cliques',
  awaiting: 'A aguardar confirmação',
  legend: {
    sent: 'Enviado',
    clicked: 'Clicado',
    delivered: 'Entregue',
  },
  error_messages: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
